import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

function buildInvoiceQuery(filters, type) {
    const params = new URLSearchParams();
    params.set('type', type);

    if (filters?.start_date) params.set('start_date', filters.start_date);
    if (filters?.end_date) params.set('end_date', filters.end_date);
    if (filters?.invoicing_period) params.set('invoicing_period', filters.invoicing_period);
    if (Array.isArray(filters?.client_ids) && filters.client_ids.length > 0) {
        params.set('client_ids', filters.client_ids.join(','));
    }

    return params.toString();
}

function ConfirmationInvoice({
    isOpen,
    onClose,
    id,
    filters,
    onConfirm
}) {

    // const toggle = () => setModal(!modal);

    return (
        <>

            <Modal isOpen={isOpen} toggle={onClose} centered>
                <ModalBody>
                    <div className='conform_btn_area'>
                        {/* <Link to={`/billings/pdf-view/${id}?type=detailed`} className="main_button text-nowrap">Detailed invoice </Link>
                        <Link to={`/billings/pdf-view/${id}?type=compressed`} className="main_button text-nowrap">Compressed invoice</Link> */}
                        <Link to={`/billings/pdf-view/${id}?${buildInvoiceQuery(filters, 'detailed')}`} className="main_button text-nowrap">Detailed invoice </Link>
                        <Link to={`/billings/pdf-view/${id}?${buildInvoiceQuery(filters, 'compressed')}`} className="main_button text-nowrap">Compressed invoice</Link>
                    </div>
                </ModalBody>
                <ModalFooter>
                    {/* <button className="main_button" onClick={onConfirm}>Yes</button> */}
                    <button className="table_delete" onClick={onClose}>Cancel</button>
                </ModalFooter>
            </Modal>


        </>
    );
}

export default ConfirmationInvoice;